module.exports = __webpack_public_path__ + "assets/images/statue-01.8e722e1774109badac15299a41deda53.svg";